module.exports = __webpack_public_path__ + "img/edit2x.png?fa0d52a82dc864c4642d278ea6feca61";